function createMagnifierLens(image, surface) {
  const lens = document.createElement('div');

  lens.className = 'image-magnify-full-size';
  lens.setAttribute('aria-hidden', 'true');
  lens.style.backgroundImage = `url("${image.src}")`;
  surface.appendChild(lens);

  return lens;
}

function updateMagnifierLens(image, surface, lens, event, zoomRatio) {
  const imageBounds = image.getBoundingClientRect();
  const surfaceBounds = surface.getBoundingClientRect();

  if (
    event.clientX < imageBounds.left ||
    event.clientX > imageBounds.right ||
    event.clientY < imageBounds.top ||
    event.clientY > imageBounds.bottom
  ) {
    lens.classList.remove('is-visible');
    return;
  }

  const lensWidth = lens.offsetWidth;
  const lensHeight = lens.offsetHeight;
  const halfWidth = lensWidth / 2;
  const halfHeight = lensHeight / 2;
  const pointerX = event.clientX - surfaceBounds.left;
  const pointerY = event.clientY - surfaceBounds.top;
  const centerX = Math.min(Math.max(pointerX, halfWidth), surfaceBounds.width - halfWidth);
  const centerY = Math.min(Math.max(pointerY, halfHeight), surfaceBounds.height - halfHeight);
  const focusX = surfaceBounds.left + centerX - imageBounds.left;
  const focusY = surfaceBounds.top + centerY - imageBounds.top;

  lens.style.left = `${centerX}px`;
  lens.style.top = `${centerY}px`;
  lens.style.backgroundSize = `${imageBounds.width * zoomRatio}px ${imageBounds.height * zoomRatio}px`;
  lens.style.backgroundPosition = `${halfWidth - focusX * zoomRatio}px ${halfHeight - focusY * zoomRatio}px`;
  lens.classList.add('is-visible');
}

function enableZoomOnHover(zoomRatio) {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  if (!finePointer.matches) return;

  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    const surface = image.closest('.product__modal-opener--image');

    if (!surface || surface.dataset.hoverLensEnabled === 'true') return;

    let lens;

    const showLens = (event) => {
      if (!finePointer.matches || (event.pointerType && event.pointerType !== 'mouse')) return;

      lens ||= createMagnifierLens(image, surface);
      updateMagnifierLens(image, surface, lens, event, zoomRatio);
    };

    const hideLens = () => {
      lens?.classList.remove('is-visible');
    };

    surface.dataset.hoverLensEnabled = 'true';
    surface.addEventListener('pointerenter', showLens);
    surface.addEventListener('pointermove', showLens);
    surface.addEventListener('pointerleave', hideLens);
    surface.addEventListener('pointercancel', hideLens);
    image.addEventListener('load', () => {
      if (lens) lens.style.backgroundImage = `url("${image.src}")`;
    });
  });
}

enableZoomOnHover(2.35);
